import SearchField from 'src/components/search_field/search_field.vue'

import { useUsersStore } from 'src/stores/users.js'

const SearchBar = {
  components: { SearchField },
  data: () => ({
    searchTerm: '',
    // the account whose posts are searched, picked with @name
    accountId: null,
    hidden: true,
  }),
  emits: ['toggled'],
  watch: {
    $route: function (route) {
      if (route.name === 'search') {
        this.searchTerm = route.query.query ?? ''
        this.accountId = route.query.account ?? null
      }
    },
  },
  computed: {
    // a user object for the chip; the id alone until the user is loaded
    account: {
      get() {
        if (!this.accountId) return null
        return (
          useUsersStore().findUser(this.accountId) ?? { id: this.accountId }
        )
      },
      set(user) {
        this.accountId = user?.id ?? null
      },
    },
  },
  methods: {
    find(searchTerm) {
      const query = { query: searchTerm }
      if (this.accountId) query.account = this.accountId
      this.$router.push({ name: 'search', query })
      this.$refs.searchInput?.focus()
    },
    close() {
      if (!this.hidden) this.toggleHidden()
    },
    toggleHidden() {
      this.hidden = !this.hidden
      this.$emit('toggled', this.hidden)
      this.$nextTick(() => {
        if (!this.hidden) {
          this.$refs.searchInput?.focus()
        }
      })
    },
  },
}

export default SearchBar
